let DevTool;
if (process.env.NODE_ENV !== 'production') {
  DevTool = require('mobx-react-devtools').default;
} else {
  DevTool = () => null;
}

export default DevTool;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/DevTool.tsx